import { supabaseManager } from '@/services/supabaseManager'

export const getSupabaseClient = () => {
  return supabaseManager.getCurrentClient();
};